<template>
  <div>
    <mywebviewnowin
      @onSendHeaders="onSendHeaders"
      @onResponseStarted="onResponseStarted"
      @onCompleted="onCompleted"
      :webviewKey="webviewKey"
      ref="mywebview"
      :preload="preload"
      :src="defaultSrc"
      :isFixUserAgent="true"
      webPreferences="webSecurity=false,contextIsolation=false,nodeIntegration=true,enableRemoteModule=true"
    >
    </mywebviewnowin>
  </div>
</template>
<script>
import mywebviewnowin from "@/views/admin/webview/mywebviewnowin.vue";
export default {
  components: {
    mywebviewnowin,
  },
  data() {
    return {
      account: {},
      webviewKey: "",
      isDestory: 0,
      hasSetCookie: {},
      defaultSrc: "https://fxg.jinritemai.com/login/common",
    };
  },
  props: {
    preload: {
      type: String,
      default: () => {
        return "doudian/seller";
      },
    },
  },
  methods: {
    onCompleted: function (details) {
      this.$emit("onCompleted", details);
    },
    onSendHeaders: function (details) {
      this.$emit("onSendHeaders", details);
    },
    onResponseStarted: function (details) {
      this.$emit("onResponseStarted", details);
    },
    sleep: function (t) {
      return new Promise((resolved) => {
        setTimeout(() => {
          resolved();
        }, t * 1000);
      });
    },
    //查看
    open: async function (account, url = "", force = true, referer) {
      this.account = account;
      this.webviewKey =
        "persist:doudian-" +
        this.$call.sendSync("cryptoEvent.md5", "" + account.id);
      var mywebview = this.$refs.mywebview;
      mywebview.addProtocolListen("bytedance", (rq, cb) => {
        // console.log("bytedance", rq);
      });
      await mywebview.hideWebView();
      await mywebview.show();
      let cookies = this.$utils.readJsonByCache(
        "cache/doudian/doudian-" + account.id
      );
      if (cookies) {
        // console.log("准备设置cookie");
        await mywebview.setCookies("https://www.jinritemai.com/", cookies);
        if (url) {
          let nurl = new URL(url);
          await mywebview.setCookies(nurl.origin, cookies);
        }
      }
      await this.sleep(4);
      console.log("准备跳转----fxg.jinritemai.com/create");
      // await mywebview.pageGoIn("https://fxg.jinritemai.com/ffa/g/create?btm_ppre=a0.b0.c0.d0&btm_pre=a2427.b76571.c902327.d871297&btm_show_id=28a73a7a-b452-436f-bfb1-6d1ac1a4ebf4");
      // console.log("设置cookie完毕,延迟完毕----fxg.jinritemai.com/create");
      // await mywebview.waitPing();
      // await this.sleep(2);
      // mywebview.showDebug();
      return true;
    },
    goPage: async function (url) {
      var mywebview = this.$refs.mywebview;
      await mywebview?.pageGo(url);
      return { code: 1, msg: "跳转成功" };
    },
    publish: async function (shop, schema) {
      var mywebview = this.$refs.mywebview;
      return await mywebview.call(
        "publish",
        {
          shop: shop,
          schema: schema,
        },
        60 * 1
      );
    },
    setStyle: function (style) {
      var mywebview = this.$refs.mywebview;
      mywebview.setStyle(style);
    },
    editPublish: async function (shop, schema) {
      var mywebview = this.$refs.mywebview;
      return await mywebview.call(
        "edit-publish",
        {
          shop: shop,
          schema: schema,
        },
        60 * 1
      );
    },
    callMethod: async function (action, params) {
      var mywebview = this.$refs.mywebview;
      return await mywebview.call(action, params, 60 * 1);
    },
  },
};
</script>
